export const SIGN_UP_ERROR = {
    EXIST_PHONE: 1,
    EXIST_EMAIL: 2,
};
export const IN_PROGRESS_STATUS = 1;
export const ASSIGNED_STATUS = 3;
export const CIVILITE = {
    MADAME: 2,
    MONSIEUR: 1
}